/**
 * Miscellaneous color definitions (calendar, technician status, search, shift, details)
 */
import { palette, createColor } from './palette.colors';

export const calenderColors = {
  textColor: createColor(palette.gray.darker, palette.gray.white),
  disabledText: createColor(palette.gray.dark, palette.gray.text),
};

export const technicianStatusColors = {
  BGOffline: createColor(palette.status.offline.bg, palette.dark.background),
  textOffline: createColor(palette.status.offline.text, palette.gray.white),
  BGOnline: createColor(palette.status.online.bg, palette.dark.background),
  textOnline: createColor(palette.status.online.text, palette.semantic.mediumGreen),
};

export const searchInputColors = {
  input: createColor(palette.gray.white, palette.gray.white),
  border: createColor(palette.gray.neutral, palette.gray.neutral),
  iconColor: createColor(palette.gray.dark, palette.gray.dark),
  resultColor: createColor(palette.gray.dark, palette.gray.dark),
};

export const shiftStatusColors = {
  greetColor: createColor(palette.gray.white, palette.gray.white),
  titleColor: createColor(palette.gray.white, palette.gray.white),
  subTitleColor: createColor(palette.gray.white, palette.gray.white),
  role: createColor(palette.gray.white, palette.gray.white),
  bay: createColor(palette.gray.white, palette.gray.white),
  iconBGColor: createColor(palette.gray.iconBG, palette.gray.iconBG),
  iconColor: createColor(palette.gray.black, palette.gray.black),
  dotIconColor: createColor(palette.gray.white, palette.gray.white),
  shiftTimeBG: createColor(palette.opacity.darkest1A, palette.opacity.darkest1A),
  shiftTimeBorder: createColor(palette.opacity.white20, palette.opacity.white20),
  shiftTimeTitle: createColor(palette.gray.white, palette.gray.white),
  shiftTimeSubTitle: createColor(palette.gray.white, palette.gray.white),
  shiftLine: createColor(palette.opacity.white20, palette.gray.disabledCTABG),
  repairShiftLine: createColor(palette.opacity.black13, palette.opacity.black13),
  activeStatusBG: createColor(palette.gray.white, palette.gray.lightDarkGrey),    // white background for status badge
  activeStatusText: createColor(palette.gray.black, palette.gray.white),  // black text for status badge
};

export const beginShiftColors = {
  borderColor: createColor(palette.semantic.darkGreen, palette.semantic.darkGreen),
  BGColor: createColor(palette.gray.white, palette.gray.white),
  textColor: createColor(palette.blue.onTint, palette.gray.darkest),
  iconColor: createColor(palette.blue.onTint, palette.gray.darkest),
  dotColor: createColor(palette.semantic.brightGreen, palette.semantic.brightGreen),
};

export const endShiftColors = {
  borderColor: createColor(palette.semantic.darkRed, palette.semantic.darkRed),
  BGColor: createColor(palette.gray.white, palette.gray.white),
  textColor: createColor(palette.blue.onTint, palette.gray.darkest),
  iconColor: createColor(palette.blue.onTint, palette.gray.darkest),
  dotColor: createColor(palette.gray.white, palette.gray.white),
};

export const detailColors = {
  separator: createColor(palette.gray.separator, palette.dark.borderLight),
  cardSeparator: createColor(palette.gray.borderLight, palette.dark.borderLight),
  labelTextColor: createColor(palette.blue.onTint, palette.gray.white),
  valueTextColor: createColor(palette.gray.darkest, palette.dark.text),
  borderColor: createColor(palette.gray.neutral, palette.dark.borderLight),
  ctaBGColor: createColor(palette.opacity.gray80, palette.opacity.gray80),
  textColor: createColor(palette.gray.lightDarkGrey, palette.gray.tabDisabled),
  dotColor: createColor(palette.gray.charcoal, palette.dark.textAlt),
  ctaColor: createColor(palette.gray.darkest, palette.dark.text),
  descriptionTextColor: createColor(palette.blue.onTint, palette.gray.white),
  repairIdTextColor: createColor(palette.gray.darkest, palette.dark.text),
  repairIdValueColor: createColor(palette.gray.charcoal, palette.dark.textAlt),
  truckTitle: createColor(palette.gray.darkest, palette.dark.text),
  partsDescTextColor: createColor(palette.gray.lightDarkGrey, palette.gray.white)
};

export const viewAllColors = {
  CTABorder: createColor(palette.gray.neutral, palette.dark.borderLight),
  CTABG: createColor(palette.gray.white, palette.dark.content),
  textColor: createColor(palette.gray.darkest, palette.dark.text),
  CTAIcon: createColor(palette.gray.black, palette.gray.white),
};
